<script>
  import ClickOut from '../../../../utils/directives/clickout'
  export default{
    name: 'btn-acoes-complementares-preparacao-leilao',
    data () {
      return {
        open: false
      }
    },
    computed: {
    },
    mounted () {},
    destroyed () {
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      }
    },
    directives: {ClickOut},
    components: {}
  }
</script>

<template>
  <div class="btn-group dropdown" :class="{open: open}"  v-click-out="hide">
    <button class="btn btn-sm btn-dark" data-toggle="dropdown" tabindex="1" aria-expanded="false" @click.stop.prevent="toggle"><i class="fa fa-gear m-r-xs"></i> Ações complementares à preparação do leilão <span class="caret"></span></button>
    <ul class="dropdown-menu no-padder">
      <li>
        <a @click="$emit('forcarOutraImportacao')" tabindex="2"><i class="fa fa-star-o fa-fw"></i> Fazer nova importação para este leilão</a>
      </li>
      <li>
        <a @click="$emit('importacaoSecundaria')" tabindex="2"><i class="fa fa-upload fa-fw"></i> Importação Secundária (CSV)</a>
      </li>
    </ul>
  </div>
</template>



// WEBPACK FOOTER //
// BtnAcoesComplementaresPreparacaoLeilao.vue?ddcd964e